import React from "react";

const CommonInput = ({
  label,
  subLabel,
  name,
  placeholder,
  value,
  required = false,
  type = "text",
  register = () => ({}),
  validation,
  onChange,
  onInput,
  onKeyPress,
  onKeyDown,
  onFocus,
  max,
  id,
  min,
  disable,
  onPaste,
  valueCheck,
}) => {
  const registration = register(name);
  

  function toggleVisibility() {
    var pass = document.getElementById("confirmBankPass");
    var eyeicon = document.getElementById("eyeicon");
    if (pass.type === "password") {
      pass.type = "text";
      eyeicon.className = "icon-Pass_hide";
    } else {
      pass.type = "password";
      eyeicon.className = "icon-Pass_see";
    }
  }

  return (
    <div className="form-group">
      <label className="form-label">
        {label}
        {subLabel && (
          <span style={{ color: "gray", fontSize: "11px", marginLeft: "3px" }}>
            {subLabel}
          </span>
        )}{" "}
        {required && <span style={{ color: "red" }}>*</span>}
      </label>
      <div className={`${label === "Confirm Bank Account Number" ? 
        "rm-custom-dropdown nominee-input custom-eye" : 
        "rm-custom-dropdown nominee-input" }`}>
        <input
          type={type}
          name={name}
          className={`${disable ? "input-st disable-input" : "input-st"}`}
          placeholder={placeholder}
          autoComplete="new-password"
          maxLength={max}
          minLength={min}
          id={id}
          onKeyDown={onKeyDown}
          onFocus={onFocus}
          onPaste={onPaste}
          onInput={(e) => {
            onInput?.(e);
            registration.onInput?.(e);
          }}
          onChange={(e) => {
            onChange?.(e);
            registration.onChange?.(e);
          }}
          onKeyPress={(e) => {
            onKeyPress?.(e);
            registration.onKeyPress?.(e);
          }}
          ref={registration.ref}
          defaultValue={value}
          disabled={disable}
          value={valueCheck}
        />
{label === "Confirm Bank Account Number" &&
          <div className="visible-pass">
              <span
                onClick={toggleVisibility}
                id="eyeicon"
                className={"icon-Pass_see" ? "icon-Pass_see" : "icon-Pass_hide"}
              ></span>
          </div>
}
      </div>
    </div>
  );
};

export default CommonInput;
